import React from 'react';

import {Stack, Typography} from 'views/components';
import {SendOutlined} from 'views/icons';
import {Translate} from 'views/module';

const MagicLinkSentBox = () => {
  return (
    <Stack
      alignItems="center"
      spacing={{xs: 2, sm: 4}}
    >
      <SendOutlined
        sx={{
          height: {
            xs: 36, sm: 52,
          },
          width: {
            xs: 36, sm: 52,
          },
          color: 'text.contrast',
        }}
      />
      <Stack spacing={1} alignItems="center">
        <Typography variant="h4" fontWeight="normal" align="center" color="text.primary">
          <Translate expression='auth.MagicLink.Sent' />
        </Typography>
        <Typography variant="body1" color="text.primary" align="center">
          <Translate expression='auth.MagicLink.SentSubtitle' />
        </Typography>
      </Stack>
    </Stack>
  );
};

export default MagicLinkSentBox;
